import _ from 'lodash';

const state = {
    order: null,
};

const getters = {
    activeOrder: state => state.order,
    isOrderLoaded: state => state.order !== null,
};


const mutations = {
    setActiveOrder: (state, order) => {
        state.order = _.cloneDeep(order);
    },
};

export default {
    state,
    getters,
    mutations,
};
